import { render, staticRenderFns } from "./UpdateModal.vue?vue&type=template&id=ed61a61e&scoped=true"
import script from "./UpdateModal.vue?vue&type=script&lang=js"
export * from "./UpdateModal.vue?vue&type=script&lang=js"
import style0 from "./UpdateModal.vue?vue&type=style&index=0&id=ed61a61e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed61a61e",
  null
  
)

export default component.exports